export function getToken(state) {
  return state.user.token
}

export function getStripePaymentMethodId(state) {
  return state.payment.stripePaymentMethodId
}
